import { useEffect, useState } from "react";
import MicrosoftLogin from "react-microsoft-login";
import { Button } from "antd";
import microsoftLogo from "../../img/microsoft_icon.svg";
import { useDispatch } from "react-redux";
import styles from "./Login.module.css";
import AuthService from "../../services/auth/AuthService";
import {
  setProfile,
  setUserPermissions,
} from "../../redux/actions";
import NotificationsUtil from "../shared/utils/NotificationsUtil";
import { NOTIFICATION_TYPES } from "../../config/constants";

const LoginMicrosoft = ({ isLoginInProgress }: { isLoginInProgress: any }) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const authHandler = (err: any, data: any, msal: any) => {
    if (!!data?.accessToken) {
      handleSignIn(data.accessToken, msal);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const tokenSubstring = window.location.hash.substring(window.location.hash.indexOf("id_token") + "id_token=".length, window.location.hash.length);
    const idToken = tokenSubstring.substring(0, tokenSubstring.indexOf("&"));
    if (!!idToken) {
      // remove everything after # to avoid login retry in the case of failed sign-in
      window.history.pushState("loginPage", "Login", window.location.href.substring(0, window.location.href.indexOf("#")));
      handleSignIn(idToken, null);
    }
  }, []);

  useEffect(() => {
    isLoginInProgress(isLoading);
  }, [isLoading]);

  const handleSignIn = (accessToken: string, msal: any) => {
    const model = {
      accessToken: accessToken,
    };
    AuthService.loginAzure(model)
      .then((response: any) => {
        if (!response.data || response?.data?.id === -1) {
          NotificationsUtil.openNotificationDialog({
            message: "Failed to login",
            description: "Provided account is not allowed.",
            placement: "bottomRight",
            type: NOTIFICATION_TYPES.ERROR,
            logError: false,
          });
        } else {
          const profile = {
            id: response.data.id,
            displayName: response.data.displayName,
            email: response.data.email,
            accessToken: response.data.accessToken,
            isSocial: response.data.isSocial,
            msal: msal,
          };
          dispatch(setProfile(profile));
          dispatch(setUserPermissions(response.data.permissions));
        }
      })
      .catch((error: any) => {
        NotificationsUtil.openNotificationDialog({
          message: "Failed to login",
          description: error.response.data,
          placement: "bottomRight",
          type: NOTIFICATION_TYPES.ERROR,
          logError: false,
        });
      })
      .finally(() => {
        isLoginInProgress(false);
      });
  };

  return (
    <div className={styles.signIn_microsoft} style={{ textAlign: "center" }}>
      {" "}
      <MicrosoftLogin
        clientId={"458bf2bd-659b-4ab2-a840-d3b0321c265b"}
        authCallback={authHandler}
        prompt={"select_account"}
        forceRedirectStrategy={true}
      >
        <Button
          disabled={isLoading}
          size="large"
          className={styles.microsoft_login}
          onClick={() => setIsLoading(true)}
        >
          <div className={styles.signIn_wrap}>
            <img src={microsoftLogo} />
            <span>Sign In with Microsoft</span>
          </div>
        </Button>
      </MicrosoftLogin>
    </div>
  );
};

export default LoginMicrosoft;
